import { useTranslation } from "react-i18next";
import Modal from "./Modal";

type Props = {
  switchToHTMLMode: () => void;
  pasteInPlainText: () => void;
}

const PasteContentModal = (props: Props) => {
  const { switchToHTMLMode, pasteInPlainText } = props;
  const { t } = useTranslation();

  return (
    <Modal
      title={t("Do you want to paste the HTML code as plain text?")}
      primaryButtonProps={{ onClick: switchToHTMLMode, text: t('Switch to HTML Source Mode') }}
      secondaryButtonProps={{ onClick: pasteInPlainText, text: t('Paste as Plain Text') }}
    >
      <p>
        {t("It seems like you are trying to paste HTML code, but since the editor is set to rich text mode, we'll paste the code as plain text.")}
        {t("Do you want to switch to HTML Source Mode?")}
      </p>
    </Modal>
  );
}

export default PasteContentModal;
